export default __webpack_public_path__ + "static/psg-dover-logo-a90eb92f66907942df6a3531e7e20f68.png";